import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  text: "Je passais littéralement tous mes dimanches après-midi à chercher de nouvelles musiques, inventer des chorégraphies et structurer mes cours. Depuis que j'utilise DANCE PRO™, je choisis un thème, j'adapte les progressions prêtes à l'emploi et mon cours est prêt en 15 minutes. J'ai retrouvé mes week-ends !",
  author: 'Marie L.',
  role: 'Professeur de Modern Jazz, 34 ans'
}, {
  text: "Ce système a sauvé mon année. Gérer une école avec plus de 150 élèves de niveaux différents était devenu un cauchemar logistique. Le 'Program Planning System' m'a permis de structurer toute l'année de septembre au gala de fin d'année. Mes professeurs assistants l'utilisent aussi maintenant.",
  author: 'Sophie D.',
  role: "Directrice d'école de danse, 42 ans"
}, {
  text: "Les progressions pédagogiques sont incroyablement claires. J'avais toujours peur de brûler les étapes avec mes élèves débutants, mais la 'Movement Library' détaille parfaitement comment amener un mouvement complexe étape par étape. Mes élèves progressent beaucoup plus vite et en toute sécurité.",
  author: 'Camille R.',
  role: 'Professeur de Classique, 28 ans'
}, {
  text: "J'avais beaucoup de mal à structurer mes cours d'éveil pour les tout-petits, ils perdaient vite leur concentration. Grâce au bonus 'Dance Motivation Academy', j'ai intégré des jeux et des défis qui les gardent captivés pendant toute l'heure. Les parents me félicitent pour le dynamisme des cours !",
  author: 'Léa M.',
  role: "Professeur d'Éveil à la danse, 31 ans"
}, {
  text: "Un gain de temps incroyable. Rien que les fiches d'évaluation et les feuilles de présence du 'Dance Teacher Toolkit' valent le prix du programme. Tout est beau, professionnel et prêt à imprimer. Je me sens beaucoup plus légitime et organisée face à mes élèves et leurs parents.",
  author: 'Isabelle V.',
  role: 'Professeur de Contemporain, 45 ans'
}];
export function Testimonials() {
  return <section className="py-8 px-4 sm:px-6 bg-brand-ivory border-y-4 border-brand-cream" data-id="element-164" data-mp="1xh7n6s4ya4ph">
      <div className="text-center mb-6" data-id="element-165" data-mp="1sjpe91qxnphh">
        <h2 className="text-2xl sm:text-3xl font-heading font-bold text-brand-title mb-2 uppercase leading-tight" data-id="element-166" data-mp="1oh2hcmfenedf">
          CE QU'EN PENSENT LES PROFESSEURS
        </h2>
        <p className="text-sm sm:text-base font-subheading font-bold text-brand-rose uppercase tracking-wide" data-id="element-167" data-mp="1jkc1o07iiksj">
          Des centaines de professeurs gagnent déjà du temps
        </p>
      </div>

      <div className="flex flex-col gap-4" data-id="element-168" data-mp="19qbp5d9wid9s">
        {testimonials.map((t, i) => <div key={i} className="bg-white border border-brand-cream p-5 rounded-lg shadow-sm hover:shadow-md transition-shadow" data-id="element-169" data-mp="14tv5owdncn31" data-mpi={i}>
            <div className="flex gap-1 mb-3" data-id="element-170" data-mp="vswy64401xfp">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-171" data-mp="qtaizp4m2749" data-mpi={i} />)}
            </div>
            <p className="text-brand-text font-medium mb-4 leading-relaxed italic text-sm sm:text-base" data-id="element-172" data-mp="37g0evacwii4v">
              "{t.text}"
            </p>
            <div className="border-t border-brand-cream pt-3 flex items-center gap-3" data-id="element-173" data-mp="3cg4yh993vszb">
              <div className="w-10 h-10 rounded-full bg-brand-rose/10 flex items-center justify-center text-brand-rose font-bold text-base border border-brand-rose/20" data-id="element-174" data-mp="3ggym01imz5ro">
                {t.author.charAt(0)}
              </div>
              <div className="leading-tight" data-id="element-175" data-mp="2oq0swwccxj5o">
                <p className="font-bold text-brand-title text-sm" data-id="element-176" data-mp="2srcmte29kqjo">{t.author}</p>
                <p className="text-[11px] sm:text-xs text-brand-text/80 font-bold uppercase tracking-wide mt-1" data-id="element-177" data-mp="2sp9nu4j4vn2t">
                  {t.role}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}